import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DimensionInput from "@/components/UI/DimensionInput.vue";
import { addSizeToDataLayer } from "@/functions/analytics";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuarterCircleDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'quarter-circle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const radius = computed({
	get: () => dimensions.value.radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "radius",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "quarter-circle-radius",
        id: `${_ctx.prefix}measurements-quarter-circle-radius`,
        name: `${_ctx.prefix}measurements[dimensions][radius]`,
        unit: "cm",
        label: dimensionLabel.value('radius', 'quarter-circle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('radius'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}quarter-circle-radius`),
        onBlur: () => _unref(addSizeToDataLayer)('radius', +radius.value, 'quarter-circle'),
        modelValue: radius.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radius).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})